export const UploadType = {
    AddOrganizations: 0,
    AddOrganizationEmails: 1,
    DeleteOrganizationEmails: 2,
    AddUsers: 3,
    DeleteUsers: 4,
}

export const UploadStatus = {
    Queued: 0,
    InProgress: 1,
    Completed: 2,
    CompletedWithErrors: 3,
    Failed: 4,
}

export const KeepMdnMode = {
    No: 0,
    Yes: 1,
    OnDemand: 2,
}

export const MdnDispatchMode = {
    /// <summary>
    /// Dispatch MDN based on conditions (default behavior).
    /// The behavior is determined by whether it was requested in the message or not
    /// </summary>
    Conditional: 0,

    /// <summary>
    /// Always send MDN.
    /// </summary>
    AlwaysSend: 1,

    /// <summary>
    /// Send MDN only on demand (GCP backend only).
    /// </summary>
    OnDemand: 2
}

// The GCP Direct Portal API (management-api) numbers Keep MDN / Send Dispatched MDN
// values differently than this portal's internal KeepMdnMode/MdnDispatchMode enums above
// (GCP wire: OnDemand=0, Yes/AlwaysSend=1, No/Conditional=2 vs. internal: No/Conditional=0,
// Yes/AlwaysSend=1, OnDemand=2 — see CPPCON-1212). The swap is self-inverse (0<->2, 1
// unchanged), so this one function converts in both directions at the GCP wire boundary.
// SES4 never sees a value other than 0/1, so non-GCP code paths must not call this.
export const translateMdnValueGcpWire = (value) => (value === 1 ? 1 : 2 - value);

// Resolves an organization classification code (FK to dbo.OrgClassifications.Code) to its display
// name using the lookup list loaded at login into sharedObject.orgClassifications.
export const classificationName = (classifications, code) => {
    if (!code) return "";
    const match = classifications?.find((c) => c.code === code);
    return match ? match.name : "";
};